__webpack_require__.p = "/editor/";